import { BasicAsyncEnumerable } from "../BasicAsyncEnumerable.js";
export const union = (first, second, comparer) => {
    if (comparer) {
        return union2(first, second, comparer);
    }
    else {
        return union1(first, second);
    }
};
const union1 = (first, second) => {
    async function* iterator() {
        const set = new Set();
        for await (const item of first) {
            if (set.has(item) === false) {
                yield item;
                set.add(item);
            }
        }
        for await (const item of second) {
            if (set.has(item) === false) {
                yield item;
                set.add(item);
            }
        }
    }
    return new BasicAsyncEnumerable(iterator);
};
const union2 = (first, second, comparer) => {
    async function* iterator() {
        const result = [];
        for (const source of [first, second]) {
            for await (const value of source) {
                let exists = false;
                for (const resultValue of result) {
                    if (comparer(value, resultValue) === true) {
                        exists = true;
                        break;
                    }
                }
                if (exists === false) {
                    yield value;
                    result.push(value);
                }
            }
        }
    }
    return new BasicAsyncEnumerable(iterator);
};
